//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ToolTip from "@/pccomponents/ToolTip";
    export default {
      name: "rowtag",
      components: {
        ToolTip
      },
      data() {
         return {
            selectOptions:this.list,
            dropValue:''
         }
      },
      props:{
        type:{
          type:String,
          default:""
        },
        prop:{
          type:String,
          default:""
        },
        rules:{
          type:Array,
          default: () => []
        },
        value:{
          type:null,
          default:""
        },
        label:{
          type:String,
          default:""
        },
        placeholder:{
          type:String,
          default:""
        },
        matchItem:{
          type:String,
          default:""
        },
        editItem:{
          type:String,
          default:""
        },
        //手动控制字段是否可以编辑，默认true为可编辑
        isEdit:{
          type: Boolean,
          default: true
        },

        list:{
          type:Array,
          default: () => []
        },
        //回调函数,当type为select、radio、checkbox时，可以传入回调参数，当值改变时会执行回调方法
        // callbackFun:{
        //   type:Function,
        //   default:null
        // },

        selectcode:{
          type : String,
          default:""
        },
        paras : {
          type:null,
          default: ""
        },
        hasnull:{
          type : String,
          default:"true"
        },
        defval:{
          type : null,
          default:""
        },
        tagname:{
          type:String,
          default:""
        },
        showLabelToolTip: {
            type: Boolean,
            default: false
        },
        showToolTip: {
            type: Boolean,
            default: false
        },
        toolTipContent: {
            type: String,
            default: ""
        },
        //传入相应选择组件的ref,推荐都使用当前fftag的prop ('select'+当前fftag的prop)
        //多行需要添加当前行项的序号 ('select'+当前fftag的prop+序号)
        selectRefName: {
            type: String,
            default: ""
        },
        minNum:{
          type: Number,
          default: -9999
        },
        maxNum:{
          type: Number,
          default:9999
        }
      },
      
      methods:{
        initSelect : function(){
          if(this.type == "select" && this.selectcode != ""){
              let paramArray = {
                  showcode: "selectOptions",//存放返回的下拉框参数的变量
                  selectcode:this.selectcode,//获取查询语句
                  hasnull:this.hasnull,
                  paras:this.paras,//TOOLS为sys_cdfcodeconfig表对应的DFIELDID字段，用于填入查询语句，查出下拉数据
              };
              this.initDropDown(this,paramArray);
              //设置默认值
              if(this.defval != "" && this.value == ""){
                this.value = this.defval;
              }
          }
        },
        /**
         * 当input为选择框时，添加点击事件关联选择框
         */
        selectOption : function(){
          if(this.selectRefName!=''){
            let currComponent=this.findComponentUpward(this.$parent);
            currComponent.$refs['selectIcon'].click();
          }
        },
        /**
         * 递归获取选择框组件
         */
        findComponentUpward : function(currComponent){
          if(this.isNotNullOrEmpty(currComponent.$refs[this.selectRefName])){
            return currComponent.$refs[this.selectRefName];
          }else{
            return this.findComponentUpward(currComponent.$parent)
          }
        },
        /**
         * 下拉框提示信息
         */
        getSelTitleTip: function(val){
          if (val != ""){
            let result = this.list.filter(elmt => elmt.propertyValue === val)
            if (result.length > 0 && result[0].hasOwnProperty("tips") && this.isNotNullOrEmpty(result[0].tips)){
                return result[0].tips
            }
          }
        }
      },
      computed: {
        monthFormate:function(){
          var sysname = process.env.SYS_NAME;
          let currvalue = this.value;
          if(sysname != 'HR' || currvalue == null || currvalue == ''){
             return "MM-yyyy"
          }
          let month = currvalue.split("-")[0];
          let f_month = "";
          switch(month) {
            case '01' : f_month = "Jan"; break;
            case '02' : f_month = "Feb"; break;
            case '03' : f_month = "Mar"; break;
            case '04' : f_month = "Apr"; break;
            case '05' : f_month = "May"; break;
            case '06' : f_month = "Jun"; break;
            case '07' : f_month = "Jul"; break;
            case '08' : f_month = "Aug"; break;
            case '09' : f_month = "Sept"; break;
            case '10' : f_month = "Oct"; break;
            case '11' : f_month = "Nov"; break;
            case '12' : f_month = "Dec"; break;
            default:   f_month = "MM"; break;

          }
          return "'"+f_month+"'-yyyy"
        },
        timeFormate:function(){
          var sysname = process.env.SYS_NAME;
          let currvalue = this.value;
          if(sysname != 'HR' || currvalue == null || currvalue == ''){
             return "dd-MM-yyyy"
          }
          let month = currvalue.split("-")[1];
          let f_month = "";
          switch(month) {
            case '01' : f_month = "Jan"; break;
            case '02' : f_month = "Feb"; break;
            case '03' : f_month = "Mar"; break;
            case '04' : f_month = "Apr"; break;
            case '05' : f_month = "May"; break;
            case '06' : f_month = "Jun"; break;
            case '07' : f_month = "Jul"; break;
            case '08' : f_month = "Aug"; break;
            case '09' : f_month = "Sept"; break;
            case '10' : f_month = "Oct"; break;
            case '11' : f_month = "Nov"; break;
            case '12' : f_month = "Dec"; break;
            default:   f_month = "MM"; break;

          }
          return "dd-'"+f_month+"'-yyyy"
        },
        getSelectOptions : function (){  
            if(this.list != ""){
              return this.list;
            }
            return this.selectOptions;
        },
        getSelectLabel:function(){
          let selectLabel = '';
          for(let item of this.getSelectOptions){
            let val = item.propertyValue;
            if(val === this.value && this.isNotNullOrEmpty(val)){
              selectLabel = item.propertyLabel;
              break;
            }
          }
          return selectLabel;
        },
        ininMoney:function()
        {
          let moneyval="";
           if(this.type == "money" )
           {
             //let reg = /(\d)(?=(?:\d{4})+$)/g;
             moneyval= this.commaFy(this.value);
           }
           return moneyval;
        } ,
        readonly: function () {
          if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
            //需要返回,true,设为只读
            return true
          }else{
            return false
          }
        },
        checkboxData:{
          get:function(){
            if(this.value==''){
              return [];
            }else{
              return this.value;
            }
          },
          set:function(val){
            this.$emit('input',val)
          }
        },
        currentvalue:{
          get:function(){
            return this.value;
          },
          set:function(val){
            this.$emit('input',val)
          }
        }
      }
    }



// WEBPACK FOOTER //
// ./src/pccomponents/rowtag.vue